<script setup lang="ts">
import type { Article_Plain } from '@webamboos/admin'

defineProps<{
  article: Article_Plain
}>()

const localePath = useLocalePath()
const { formatDate } = useDate()
</script>

<template>
  <NuxtLink
    :to="localePath(`/blog/${article.slug}`)"
    class="hover:bordershadow-lg-gray group group flex h-fit flex-col gap-y-4 rounded-lg p-2 transition hover:bg-black/5"
  >
    <div class="w-full">
      <NuxtImg
        :src="article.image.url"
        :alt="article.image.alternativeText"
        :width="640"
        :height="400"
        class="bordershadow-gray aspect-video w-full min-w-0 rounded object-cover transition"
        :class="class"
      />
    </div>

    <div class="flex w-full flex-col gap-y-2 px-4 pb-4 pt-2">
      <Paragraph size="small">
        <time class="flex items-center gap-1">
          <div v-if="article.category" class="flex items-center gap-1">
            <span class="text-main-500 font-medium">{{ article.category.name }} </span>
            <span>—</span>
          </div>
          {{ formatDate(article?.publishedAt as Date) }}
        </time>
      </Paragraph>
      <Heading as="h2" size="medium" gradient="gray">
        {{ article.title }}
      </Heading>
      <Paragraph size="normal" class="line-clamp-3 overflow-hidden">
        {{ article.description }}
      </Paragraph>
    </div>
  </NuxtLink>
</template>
